/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Priority/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PriorityLabel from './PriorityLabel/index'
import React from 'react'
import TysiaIconSortAsc from 'DesignSystem/Svgs/TysiaIconSortAsc/index'
import TysiaSelectOneGhost from 'DesignSystem/TysiaSelectOneGhost/index'
import TysiaSelectOneGhostArrow from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow/index'
import TysiaSelectOneGhostContent from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent/index'
import TysiaSelectOneGhostIcon from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Priority({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Priority",
  onChange
  
}) {
let prioritiesValueData = fromData.useDataValue({ viewPath,
context: 'priorities',
})
let selectedDataNewTaskPriorityValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'data.new_task.priority',
})
let selectedDataNewTaskPriorityChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'data.new_task.priority',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaSelectOneGhost
  viewPath={`${viewPath}/TysiaSelectOneGhost`}
 data="priorities"
 from={prioritiesValueData}
 placeholder="Priority"
 data="selected.data.new_task.priority"
 value={selectedDataNewTaskPriorityValueData}
 onChange={selectedDataNewTaskPriorityChangeData}
 keepFilter={true}
>
{childProps => (
<TysiaSelectOneGhostContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneGhostIcon
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostIcon`}
>
{childProps => (
<TysiaIconSortAsc
{...childProps}
  viewPath={`${viewPath}/TysiaIconSortAsc`}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaSelectOneGhostIcon>
<PriorityLabel
{...childProps}
  viewPath={`${viewPath}/PriorityLabel`}
/>
<TysiaSelectOneGhostArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneGhostContent>
)}
</TysiaSelectOneGhost>
{children}
</React.Fragment>)
}